module.exports = __webpack_public_path__ + "img/logo.cf0d61b1.svg";